import Vue from 'vue'
import App from './App.vue'
import store from './store'

import './css/style.sass'

Vue.config.productionTip = false

/** Public Component */
import Select from './components/select.vue';
let mf_select = Vue.extend(Select);
Vue.component('mf_select', mf_select);

import Slider from './components/slider.vue';
let slider = Vue.extend(Slider);
Vue.component('slider', slider);

import ToggleButton from './components/togglebutton.vue';
let togglebutton = Vue.extend(ToggleButton);
Vue.component('togglebutton', togglebutton);

import ModeChanger from './components/modeChanger.vue';
let modeChanger = Vue.extend(ModeChanger);
Vue.component('modeChanger', modeChanger);

import CloseButton from './components/closebutton.vue';
let closebutton = Vue.extend(CloseButton);
Vue.component('closebutton', closebutton);

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
